var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64.001,
    viewBox: "0 0 64 64.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M22858-6862a31.806,31.806,0,0,1-12.455-2.515,31.887,31.887,0,0,1-10.17-6.858,31.85,31.85,0,0,1-6.857-10.17A31.808,31.808,0,0,1,22826-6894a31.823,31.823,0,0,1,2.516-12.458,31.857,31.857,0,0,1,6.857-10.172,31.866,31.866,0,0,1,10.17-6.859A31.806,31.806,0,0,1,22858-6926a31.808,31.808,0,0,1,12.457,2.515,31.88,31.88,0,0,1,10.172,6.859,31.857,31.857,0,0,1,6.857,10.172A31.823,31.823,0,0,1,22890-6894a31.808,31.808,0,0,1-2.516,12.455,31.85,31.85,0,0,1-6.857,10.17,31.9,31.9,0,0,1-10.172,6.858A31.808,31.808,0,0,1,22858-6862Zm0-45.5a13.417,13.417,0,0,0-9.545,3.954,13.414,13.414,0,0,0-3.955,9.546,13.514,13.514,0,0,0,13.5,13.5,13.419,13.419,0,0,0,9.551-3.956,13.411,13.411,0,0,0,3.955-9.544,13.412,13.412,0,0,0-3.955-9.546A13.424,13.424,0,0,0,22858-6907.5Z",
    transform: "translate(-22826 6926.001)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3);
export default __webpack_public_path__ + "static/media/image3.48a6bc54a8da6e3b62475caca9fafb8d.svg";
export { ForwardRef as ReactComponent };